import Forbidden403 from "../../components/Forbidden403";

const Forbidden403Page = () => {
  return <Forbidden403 />;
};

export default Forbidden403Page;
